import { projectDetailActions } from '@app/core/actions/project-detail.actions';
import { createReducer, on } from '@ngrx/store';
import { defaultEntityState } from '../entity';
import { entityKey } from '../entity-name-map';
import { mergeEntityState, removeEntitiesByFilter } from '../entity.helpers';
import { IProjectPermissionSet } from './project-permission-set.entity';

export const projectPermissionSetEntityReducer = createReducer(
  defaultEntityState<IProjectPermissionSet>(),
  on(
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.invitationsBulkRevokedSuccessfully,
    projectDetailActions.joinRequestsResponseSent,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    projectDetailActions.registered,
    projectDetailActions.agreementModeUpdated,
    (state, props) =>
      mergeEntityState(entityKey.projectPermissionSets, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  )
);
